import React from "react";

// `.list-maintext` used to rely on CSS `text-transform: capitalize` to
// display buyer_name (stored lowercase/mixed-case) — but splitting text into
// sibling nodes for highlightMatch's <mark> breaks that: browsers apply
// `capitalize` per text node, not per word across the whole rendered string,
// so "Sanat" highlighted as "S" + mark("an") + "at" rendered as "SAnAt"
// (each fragment's leading letter capitalized independently). Capitalizing
// here, before splitting, sidesteps that entirely.
export function capitalizeWords(text: string): string {
	return text.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function highlightMatch(
	text: string,
	query: string,
): React.ReactNode {
	const normalizedQuery = query.trim().toLowerCase();
	if (normalizedQuery === "") return text;

	const matchIndex = text.toLowerCase().indexOf(normalizedQuery);
	if (matchIndex === -1) return text;

	const before = text.slice(0, matchIndex);
	const match = text.slice(matchIndex, matchIndex + normalizedQuery.length);
	const after = text.slice(matchIndex + normalizedQuery.length);

	return (
		<>
			{before}
			<mark className="search-match">{match}</mark>
			{after}
		</>
	);
}
